import React from 'react';
import {
    Typography,
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
    List,
    ListItem,
    Link,
    Grid,
} from '@material-ui/core';

import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import MenuItems from './menu-items';
import { Link as RouterLink } from 'react-router-dom';
import Searchicons from '@material-ui/icons/Search';
import ClearIcons from '@material-ui/icons/Close';
import { TextField, IconButton } from '@material-ui/core';

import './style.css';

function MenuExpansion(props) {
    const { onMenuClick, selectedItem } = props;
    const [tempSearchValue, setTempSearchValue] = React.useState("");
    const [searchValue, setSearchValue] = React.useState("");
    const [isSearchMode, setIsSearchMode] = React.useState(false);
    var ChildParentItem = '';
    const selectedParentItem = () => {
        var parentItem = '';
        ChildParentItem = '';
        for (var itemIndex in MenuItems) {
            parentItem = MenuItems[itemIndex].name;
            if (parentItem === selectedItem) {
                return parentItem;
            } else {
                if (Array.isArray(MenuItems[itemIndex].items)) {
                    for (var subItemIndex in MenuItems[itemIndex].items) {
                        for (var subChildIndex in MenuItems[itemIndex].items[
                            subItemIndex
                        ].items) {
                            ChildParentItem = subItemIndex;
                            if (
                                MenuItems[itemIndex].items[subItemIndex].items[
                                    subChildIndex
                                ].name === selectedItem
                            ) {
                                return parentItem;
                            }
                        }
                    }
                }
            }
        }
        return '';
    };

    selectedParentItem();

    const [expandedIndex, setExpandedIndex] = React.useState(
        selectedItem.split('-')[0] === 'version4' ? 2 : 1
    );
    const handleExpansionPanelChange = (panelIndex) => (event, newExpanded) => {
        setExpandedIndex(newExpanded ? panelIndex : false);
    };

    const [expandedchildIndex, setExpandedChildIndex] = React.useState(
        ChildParentItem ? ChildParentItem : false
    );
    const ChildhandleExpansionPanelChange = (panelIndex) => (
        event,
        newExpanded
    ) => {
        setExpandedChildIndex(newExpanded ? panelIndex : false);
    };

    const [
        expandedGrnadchildIndex,
        setExpandedGrnadChildIndex,
    ] = React.useState();
    const GrandChildhandleExpansionPanelChange = (panelIndex) => (
        event,
        newExpanded
    ) => {
        setExpandedGrnadChildIndex(newExpanded ? panelIndex : false);
    };

    function getItem(item, e) {
        onMenuClick(e, item);
    }

    const texthandleChange = (event) => {
        if (event.target.value == '') {
            setTempSearchValue("")
            setSearchValue("")
            setIsSearchMode(false)
        } else {
            setTempSearchValue(event.target.value)
            setSearchValue(tempSearchValue)
            setIsSearchMode(true)

        };
    };

    const isRenderHeaders = () => {
        if (isSearchMode) {
            return MenuItems.some((row) => row?.items?.some(rowChild => rowChild?.items?.some(Content => Content.label.toLowerCase().includes(tempSearchValue.toLowerCase()))));
        }
        return true;
    };

    return (
        <>
            <Typography  component="div">
                <div className='docsearchborder'>
                    <div className='doccolSearch'>
                        <Searchicons className='searchIcon' />
                    </div>
                    <div className='doccolSearchtxt'>
                        <TextField id='docsearchTxtfield'
                            placeholder="CLICK HERE TO SEARCH DOCS..."
                            type="text"
                            variant="filled"
                            onChange={texthandleChange}
                            value={tempSearchValue}
                            size="small"
                            InputProps={{
                                endAdornment: tempSearchValue && (
                                    <IconButton onClick={() => { setTempSearchValue(""); setSearchValue(""); setIsSearchMode(false) }}>
                                        <ClearIcons className='clearIcon' />
                                    </IconButton>
                                )
                            }}
                        />
                    </div>
                </div>
            </Typography>
            <Grid item xs={12} sm={12} md={4} lg={4}>
                <Typography
                    component="div"
                    className={`doc-menu${' scrollbar-width-thin'} `}
                >
                    {isRenderHeaders() ? (
                        <Typography component="div" className="doc-side-nav">
                            {MenuItems
                                .map((row, index) => {
                                    return (
                                        <ExpansionPanel
                                            key={index}
                                            square
                                            defaultExpanded
                                            onChange={handleExpansionPanelChange(index)}
                                            expanded={isSearchMode ? true : expandedIndex === index}
                                        >
                                            <ExpansionPanelSummary>
                                                <List>
                                                    <ListItem
                                                        className={`doc-side-nav${selectedItem === row.name
                                                            ? ' active'
                                                            : ''
                                                            }${row.highlight
                                                                ? ' highlight'
                                                                : ''
                                                            }${row.header ? ' header' : ''}`}
                                                    >
                                                        {row.items
                                                            ? (
                                                                row.name
                                                            ) : (
                                                                <Link
                                                                    className={`docs-intro${' highlight'} `}
                                                                    component={RouterLink}
                                                                    to={'/docs'}
                                                                >
                                                                    {row.label}
                                                                </Link>
                                                            )}
                                                        {row.items ? (
                                                            expandedIndex === index ? (
                                                                <ArrowDropDown
                                                                    className={
                                                                        'sidebar-item-expand-arrow '
                                                                    }
                                                                />
                                                            ) : (
                                                                <ArrowDropUp className="sidebar-item-expand-arrow" />
                                                            )
                                                        ) : (
                                                            ''
                                                        )}
                                                    </ListItem>
                                                </List>
                                            </ExpansionPanelSummary>
                                            <ExpansionPanelDetails>
                                                {row.items ? (
                                                    <>
                                                        <List className="listMenu">
                                                            {row.items
                                                                .map(
                                                                    (rowChild, Childindex) => {

                                                                        return (
                                                                            <ExpansionPanel
                                                                                key={`${Childindex}`}
                                                                                square
                                                                                defaultExpanded
                                                                                onChange={ChildhandleExpansionPanelChange(
                                                                                    `${Childindex}`
                                                                                )}
                                                                                hidden={isSearchMode ?
                                                                                    (rowChild.items.filter(Content => Content.label.toLowerCase().includes(tempSearchValue.toLowerCase())).length == 0 ? true : false)
                                                                                    : false}
                                                                                expanded={isSearchMode ? true : expandedchildIndex === `${Childindex}`}
                                                                            >
                                                                                <ExpansionPanelSummary>
                                                                                    <ListItem
                                                                                        className={`doc-side-nav${selectedItem ===
                                                                                            rowChild.name
                                                                                            ? ' active'
                                                                                            : ''
                                                                                            }${rowChild.highlight
                                                                                                ? ' highlight'
                                                                                                : ''
                                                                                            }${rowChild.header
                                                                                                ? ' header'
                                                                                                : ''
                                                                                            }`}
                                                                                    >
                                                                                        {
                                                                                            rowChild.label
                                                                                        }
                                                                                        {expandedchildIndex ===
                                                                                            `${Childindex}` ? (
                                                                                            <ArrowDropDown
                                                                                                className={
                                                                                                    'sidebar-item-expand-arrow '
                                                                                                }
                                                                                            />
                                                                                        ) : (
                                                                                            <ArrowDropUp className="sidebar-item-expand-arrow" />
                                                                                        )}
                                                                                    </ListItem>
                                                                                </ExpansionPanelSummary>
                                                                                <ExpansionPanelDetails className="docs-child">
                                                                                    {rowChild.items ? (
                                                                                        <>
                                                                                            <List className="docs-link">
                                                                                                {rowChild.items
                                                                                                    .filter(Content => Content.label.toLowerCase().includes(tempSearchValue.toLowerCase()))
                                                                                                    .map(
                                                                                                        (
                                                                                                            rowGrandChild,
                                                                                                            grandChildindex
                                                                                                        ) => {
                                                                                                            return (
                                                                                                                <ExpansionPanel
                                                                                                                    key={`G${grandChildindex}`}
                                                                                                                    square
                                                                                                                    defaultExpanded
                                                                                                                    onChange={GrandChildhandleExpansionPanelChange(
                                                                                                                        `G${grandChildindex}`
                                                                                                                    )}
                                                                                                                    expanded={isSearchMode ? true : expandedGrnadchildIndex === `G${grandChildindex}`}
                                                                                                                                                                                                                              >
                                                                                                                    <ListItem
                                                                                                                        className={`doc-side-nav${selectedItem ===
                                                                                                                            rowGrandChild.name
                                                                                                                            ? ' active'
                                                                                                                            : ''
                                                                                                                            }${rowGrandChild.highlight
                                                                                                                                ? ' highlight'
                                                                                                                                : ''
                                                                                                                            }${rowGrandChild.header
                                                                                                                                ? ' header'
                                                                                                                                : ''
                                                                                                                            }`}
                                                                                                                        onClick={(
                                                                                                                            e
                                                                                                                        ) =>
                                                                                                                            getItem(
                                                                                                                                rowGrandChild.name,
                                                                                                                                e
                                                                                                                            )
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <Link
                                                                                                                            component={
                                                                                                                                RouterLink
                                                                                                                            }
                                                                                                                            to={`/docs-page/${rowGrandChild.name}`}
                                                                                                                        >
                                                                                                                            {
                                                                                                                                rowGrandChild.label
                                                                                                                            }
                                                                                                                        </Link>
                                                                                                                    </ListItem>
                                                                                                                </ExpansionPanel>
                                                                                                            );
                                                                                                        }
                                                                                                    )}
                                                                                            </List>
                                                                                        </>
                                                                                    ) : (
                                                                                        ''
                                                                                    )}
                                                                                </ExpansionPanelDetails>
                                                                            </ExpansionPanel>
                                                                        );
                                                                    }
                                                                )}
                                                        </List>
                                                    </>
                                                ) : (
                                                    ''
                                                )}
                                            </ExpansionPanelDetails>
                                        </ExpansionPanel>
                                    );
                                })}
                        </Typography>
                    ) : (
                        <List>
                            <ListItem
                                style={{ display: 'flex', alignItems: 'center' }}
                            >
                                <Searchicons fontSize="small" />
                                <span className="no-results-text">No results found</span>
                            </ListItem>
                        </List>
                    )}
                </Typography>
            </Grid>
        </>
    );
}

export default MenuExpansion;
